import React, { VFC, MouseEventHandler } from 'react'
import { addClassName } from 'utils'

type Props = {
  className?: string
  src: string
  width: string
  height: string
  alt?: string
  onClick?: MouseEventHandler<HTMLImageElement>
}

const Img: VFC<Props> = (props) => {
  return (
    <img
      className={`w-full h-auto ${addClassName(props.className)}`}
      src={`${process.env.PUBLIC_URL}/images/${props.src}`}
      width={props.width}
      height={props.height}
      alt={props.alt || ''}
      onClick={props.onClick}
    />
  )
}

export default Img
